
import { defineComponent } from 'vue';
import { ElMessage } from 'element-plus';
import { FullScreen } from '@element-plus/icons-vue';
import screenfull from 'screenfull';

export default defineComponent({
  name: 'Fullscreen',
  props: {
    // unusable message
    unusableMsg: {
      type: String,
      default: 'you browser can not work',
    },
  },
  components: {
    FullScreen,
  },
  setup(props) {
    const handleScreenfullChange = () => {
      if (!screenfull.isEnabled) {
        ElMessage.warning(props.unusableMsg);
        return;
      }
      screenfull.toggle();
    };

    return {
      handleScreenfullChange,
    };
  },
});
